import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {},
});

// Action creators are generated for each case reducer function
export default configSlice.reducer;
